import ActionValidator from '../../../validator/mapping-tool/action-validator';
import Condition from '../condition/condition';
export default class Action {
    constructor(dto) {
        this.dto = Object.assign({}, dto);
    }
    get id() {
        return this.dto.id;
    }
    set id(id) {
        this.dto.id = id;
    }
    get condition() {
        if (!this.dto.condition) {
            return null;
        }
        return new Condition(this.dto.condition);
    }
    set condition(condition) {
        if (condition) {
            this.dto.condition = condition.dto;
        }
        else {
            this.dto.condition = null;
        }
    }
    get type() {
        return this.dto.type;
    }
    set type(type) {
        this.dto.type = type;
    }
    get valueSettings() {
        return this.dto.valueSettings;
    }
    set valueSettings(valueSettings) {
        this.dto.valueSettings = valueSettings;
    }
    get position() {
        return this.dto.position;
    }
    set position(position) {
        this.dto.position = position;
    }
    /**
     * Return the parameters to create/update this action
     * @returns ActionParamsInterface
     */
    get params() {
        const params = {
            type: this.type,
            valueSettings: this.valueSettings,
            position: this.position,
        };
        return params;
    }
    /**
     * Return the object to validate this entity
     *
     * @returns ActionValidator
     */
    get validator() {
        return new ActionValidator();
    }
    /**
     * Returns the validation errors from the form
     */
    get validationErrors() {
        return this.validator.validate(this);
    }
    /**
     * Returns whether the form is valid
     */
    get valid() {
        return Object.keys(this.validationErrors).length === 0;
    }
}
//# sourceMappingURL=action.js.map